import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { translate } from '@fiverr-private/i18n-react';
import { MatchSellerLevel } from '../types';
import { Preference } from '../Preference';
import { Gql } from '../../../types';

const T_PREFIX = 'dynamic_matching.freelancer_preferences.fields.level';

const getMinLevelText = (minLevel: string) => translate(`${T_PREFIX}.levels.${minLevel}`);

export const LevelPreference = ({
  minLevel,
  matchIndicator,
  sellerName,
  sellerLevel,
  isSeller,
}: {
  minLevel: Gql.DmBriefSellerLevel;
  matchIndicator?: Gql.Maybe<Gql.DmBriefMatchIndicator>;
  sellerName?: string;
  sellerLevel: MatchSellerLevel;
  isSeller: boolean;
}) => {
  const tooltipContent = !isSeller ? <TooltipText sellerName={sellerName} sellerLevel={sellerLevel} /> : undefined;
  return (
    <Preference name="level" matchIndicator={matchIndicator} tooltipContent={tooltipContent}>
      <Stack width="100%" wrap="wrap" flexShrink={1}>
        <Typography color="grey_1200" as="p" size="b_md">
          {getMinLevelText(minLevel.toLowerCase())}
        </Typography>
      </Stack>
    </Preference>
  );
};

const acceptedLevels: MatchSellerLevel[] = [
  Gql.SellerLevel.LevelOne,
  Gql.SellerLevel.LevelTwo,
  Gql.SellerLevel.LevelTrs,
];

const TooltipText = ({ sellerName, sellerLevel }: { sellerName?: string; sellerLevel: MatchSellerLevel }) => {
  let levelText = '';

  if (sellerLevel === Gql.SellerLevel.NewSeller) {
    levelText = translate(`${T_PREFIX}.tooltip.new_seller`);
  } else if (acceptedLevels.includes(sellerLevel)) {
    levelText = `${translate(`${T_PREFIX}.tooltip.message`)} ${translate(
      `${T_PREFIX}.tooltip.${sellerLevel?.toLocaleLowerCase()}`
    )}`;
  } else {
    levelText = translate(`${T_PREFIX}.tooltip.no_level`);
  }

  return (
    <Typography>
      {sellerName} {levelText}
    </Typography>
  );
};
